{
  "nl": {
    "courseBookmark": {
      "title": "Opgeslagen Cursussen",
      "emptyState": {
        "title": "Je verlanglijst is nog leeg",
        "body": "Je hebt nog geen cursussen opgeslagen. Je kunt cursussen die je leuk vindt op je verlanglijst zetten. Klik hiervoor eenvoudig op het <i class='bi bi-heart text-primary'></i> icoon."
      },
      "links": {
        "toCourses": "Cursussen ontdekken"
      }
    }
  }
}
